const INIT_STATE = { data: [], error: null };
export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case "GET_ORG_ACTIVITIES_SUCCESS":
      return {
        ...state,
        data: action.payload,
        error: null,
      };
    case "GET_ORG_ACTIVITIES_ERROR":
      return { ...state, data: [], error: action.payload };
    case "GET_MY_TEAM_SUCCESS":
      return {
        ...state,
        data: action.payload,
        error: null,
      };
    case "GET_MY_TEAM_ERROR":
      return { ...state, data: [], error: action.payload };
    default:
      return state;
  }
};
